import * as T from '../constants/types';
import { initialAuthForm } from '../constants/variables';

const initialState = {
    ...initialAuthForm,
    isPasswordResetRequired: false,
};

export const loginForm = (state = initialState, { type, payload }) => {
    switch (type) {
        case T.RESET_DEFAULT_PASSWORD + T.SUCCESS:
            return { ...state, password: state.newPassword };
        case T.NEW_USER_PASSWORD_RESET:
            return { ...state, isPasswordResetRequired: true };
        case T.CHANGE_LOGIN_FORM:
            return { ...state, ...payload };
        default:
            return state;
    }
};
